import Image from 'next/image';
import Link from 'next/link';

import styles from './navigation.module.scss';

export const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    if (section) {
        section.scrollIntoView({behavior: 'smooth'});
    }
};

export function Logo() {
    return (
        <Link href="/">
            <Image
                src="/ci/images/landing/icons/udemy-logo-white.svg"
                className={styles.logo}
                alt="Udemy Logo"
                width={96}
                height={32}
            />
        </Link>
    );
}
